import { render, staticRenderFns } from "./MST_MGMT_TRGTS_ALLOC.vue?vue&type=template&id=1dd8e086&scoped=true"
import script from "./MST_MGMT_TRGTS_ALLOC.vue?vue&type=script&lang=ts"
export * from "./MST_MGMT_TRGTS_ALLOC.vue?vue&type=script&lang=ts"
import style0 from "./MST_MGMT_TRGTS_ALLOC.vue?vue&type=style&index=0&id=1dd8e086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8e086",
  null
  
)

export default component.exports